import { render, staticRenderFns } from "./eDeliveryNotes.vue?vue&type=template&id=face0f48&"
import script from "./eDeliveryNotes.vue?vue&type=script&lang=js&"
export * from "./eDeliveryNotes.vue?vue&type=script&lang=js&"
import style0 from "./eDeliveryNotes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports